import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getOrganizerProfile } from '../../../api';
import { useAuth } from '../../../context/AuthContext';
import { useNightMode } from '../../../contexts/NightModeContext';
import Background from '../../Login/Background';
import '../Payout.css';

const Onboarding = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { refreshUser } = useAuth();
    const { isNightMode } = useNightMode();
    
    const getStatus = () => {
        const path = location.pathname.toLowerCase();
        if (path.includes('/success')) return 'success';
        if (path.includes('/failure')) return 'failure';
        if (path.includes('/refresh')) return 'refresh';
        return 'unknown';
    };

    const status = getStatus();

    useEffect(() => {
        if (status === 'success') {
            const refreshData = async () => {
                try {
                    await getOrganizerProfile();
                    refreshUser();
                } catch (error) {
                    console.error('Error refreshing user data:', error);
                }
            };
            refreshData();
        }
    }, [status, refreshUser]);

    const renderContent = () => {
        switch (status) {
            case 'success':
                return {
                    iconClass: 'fa-solid fa-circle-check',
                    title: 'Stripe onboarding successful',
                    message: 'Your Stripe Connect account is set up. You can now receive payouts.',
                    tone: 'ok',
                };
            case 'failure':
                return {
                    iconClass: 'fa-solid fa-circle-xmark',
                    title: 'Stripe onboarding failed',
                    message: 'There was an issue completing onboarding. Try again or contact support if this continues.',
                    tone: 'bad',
                };
            case 'refresh':
                return {
                    iconClass: 'fa-solid fa-arrow-rotate-right',
                    title: 'Onboarding session expired',
                    message: 'Your onboarding session has expired. Start a new session from payout settings.',
                    tone: 'warn',
                };
            default:
                return {
                    iconClass: 'fa-solid fa-circle-question',
                    title: 'Unknown status',
                    message: 'Unable to determine onboarding status.',
                    tone: 'info',
                };
        }
    };

    const content = renderContent();

    const handleGoToPayouts = () => {
        navigate('/payouts');
    };

    return (
        <div className={`contact-list-container payout-page ${isNightMode ? 'text-white' : 'text-dark'}`}>
            <Background />
            <div className="payout-onboarding">
                <div className={`glass-panel payout-onboarding-card payout-status-${content.tone}`}>
                    <div className="payout-status-icon">
                        <i className={content.iconClass}></i>
                    </div>
                    <h1 className="payout-status-title">{content.title}</h1>
                    <p className="payout-status-message">{content.message}</p>
                    <div className="d-flex gap-2 justify-content-center flex-wrap">
                        {status === 'success' && (
                            <button className="v3-btn-primary" onClick={handleGoToPayouts}>
                                Go to Payouts
                            </button>
                        )}
                        {(status === 'failure' || status === 'refresh') && (
                            <>
                                <button className="v3-btn-primary" onClick={handleGoToPayouts}>
                                    Try again
                                </button>
                                <button className="v3-btn-secondary" onClick={handleGoToPayouts}>
                                    Go to Payouts
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Onboarding;
